

const serviceFeatures = [
  {
    id: 'planning',
    title: 'Project Planning and Scheduling Services',
    shortTitle: 'Planning & scheduling',
    label: 'PRIMAVERA',
    lead: 'Elevate your project success with expert Primavera-based planning and scheduling.',
    description: 'Transform your project outcomes with our expert planning and scheduling services, leveraging world-class Primavera proficiency. Specializing in minerals, metals, and infrastructure, we offer project controls, schedule portfolios, master and detailed schedules, risk analysis, and recovery plans—all tailored to your sector’s complexities. Partner with us to elevate your project’s success through strategic planning and meticulous scheduling.',
    highlights: ['Project controls', 'Master & detailed schedules', 'Risk analysis & recovery plans'],
    diagram: 'planning'
  },
  {
    id: 'value-engineering',
    title: 'Project Value Engineering Services',
    shortTitle: 'Value engineering',
    label: 'CAPEX / OPEX',
    lead: 'Enhance project financials with our value engineering and Excel-based modeling for mining and infrastructure.',
    description: 'Enhance the financial performance of your projects with our comprehensive services, including project value engineering, due diligence, and specialized Excel-based modeling. We combine project construction and operating estimates with rigorous analysis to provide detailed CAPEX and OPEX modeling. Specializing in mining, minerals, and infrastructure, our team applies targeted strategies to reduce expenses, improve resource utilization, and streamline operations.',
    highlights: ['Value engineering', 'Due diligence', 'CAPEX & OPEX modeling'],
    diagram: 'value'
  },
  {
    id: 'management-tools',
    title: 'Program and Project Management Tools',
    shortTitle: 'Project management tools',
    label: 'EXCEL-BASED TOOLS',
    lead: 'Boost project efficiency with our custom Excel tools offering powerful, data-driven features.',
    description: 'Streamline your project management processes with our customized Excel-based tools, meticulously designed to enhance efficiency, consistency, and accuracy across all your projects. Whether you’re tracking timelines, managing resources, analyzing financials, or ensuring compliance, our tools offer a familiar and user-friendly interface combined with robust, data-driven functionalities to support and optimize every aspect of your workflow.',
    highlights: ['Timeline & resource tracking', 'Financial analysis', 'Consistency & accuracy'],
    diagram: 'tools'
  },
  {
    id: 'consulting',
    title: 'Mine and Infrastructure Project Consulting',
    shortTitle: 'Project consulting',
    label: 'MINING & INFRASTRUCTURE',
    lead: 'Gain strategic insights and manage risks in your projects with expert consulting.',
    description: 'Unlock valuable insights into the risks and opportunities of your projects with our specialized consulting expertise. With experience in international projects, we offer comprehensive services to assess and manage every aspect of your project. We identify risks, discover opportunities, and provide strategic insights to ensure your projects are secure and successful. Partner with us to confidently navigate the complexities of the mining and infrastructure sectors.',
    highlights: ['Risk & opportunity assessment', 'Strategic insights', 'International project experience'],
    diagram: 'consulting'
  }
];

export default serviceFeatures;
